import React from "react";
import "../styles/home.css";
export default function Home() {
  return (
    <>
      <div className="banner">
        <div className="bannerOverlay">
          <div className="container">
            <p className="ptagMaxWidth">
              <br />
              <b> OP Nodekit: Developer tools to enable builders of iot node solutions on Optimism, Ethereum to build Web3 projects on Optimism. We are a home for Optimism tinkers, OP Stack developers & Web3 eco-system users focused towards developing iot solutions for Optimism Collective.</b>
            </p>
            {/* <p className="ptagMaxWidth">
              <i>Medicine for everyone</i>
            </p> */}
            {/* <Button href="#!" target="_blank">Any Button</Button> */}
          </div>
        </div>
      </div>



      <div className="container textAlign">
        
        <h1 className="containerH1">
            Contribution to Optimism Collective for OP RetroPGF3: OP Nodekit Projects 
        </h1>

        <h1 className="containerH1">
          {" "}
          UAV Monitor
        </h1>
        <div className="row">
          <div className=" col-md-12 col-lg-6">
            <img src="/images/droneimg.png" alt="" style={{ width: "100%" }} />
          </div>
          <div className=" col-md-12 col-lg-6">
            <p>
            Technical solution for Integrated Water and Aerial Traffic Management built using Optimism Nodekit, OP Stack and Web3 eco-system tools.
            Ensure effective design, engineering and delivery of solution for
              detecting & managing UAVs & Drones using Ethereum, optimism, IPFS &
              Filecoin eco-system tools, modular iot gateway device solution and
              Layer 2 scaling solutions.
            </p>
            <ul>
              <li>
                <strong>Detection:</strong> Identifying the UAVs in the video
                feed using object detection.
              </li>
              <li>
                <strong>Discovery:</strong> Logging the identities of UAVs
                flying in a particular air space, using exchange of unique
                identifiers.
              </li>
              <li>
                <strong>Geo-fencing:</strong> Discovering unlawful presence,
                raising alarms using w3ui.
              </li>
              <li>
                <strong>Monitoring and Reporting:</strong> Looking out and
                reporting incidents based on event detection in files uploaded
                using w3ui.
              </li>
              <li>
                <strong>Analysis:</strong> Analyzing route patterns and
                incidents.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="container">
        <div className="row">
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://github.com/aspiringsecurity/Water-ICM"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className=" image-button"
                src="images/Group 15.png"
                alt="github button"
                style={{ width: "100%" }}
              />
              Github Repository
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://www.youtube.com/watch?v=dk3TQlEsxfo"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 10.jpg"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Screencast
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://www.youtube.com/watch?v=vNKONKA2sow"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 16 (1).png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Hardware Demo 1
              <p>( End Commissioning of Nodes and Communication Set-up)</p>
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href=" https://www.youtube.com/watch?v=XOq55l0NIZI&t=1s"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 17.png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Hardware Demo 2<p>(Simulation and lab set-up)</p>
            </a>
          </div>
        </div>
      </div>

      <div className="container textAlign">
        <h1 className="containerH1">Project Information</h1>

        <ul>
          <li>
            <strong>Pitch Video at Encode Metaverse Hackathon 2022</strong>
            <a
              href="https://youtu.be/-o5qVzeV5hk?feature=shared"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>
          <li>
            <strong>Website for Civic Bodies </strong>
            <a
              href="https://sites.google.com/view/latcglobal/home"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>
          <li>
            <strong>Github link: </strong>
            <a
              href="https://github.com/aspiringsecurity/Water-ICM#optimism-eco-system"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>


        </ul>
      </div>
      <div className="container textAlign">

        <h1 className="containerH1">Contribution to Optimism and OP ecosystem:</h1>
        <ul>
          <li>Developer and DAO tools on Optimism for organization, tabulation, visualization of on-chain and off-chain data.</li>
          <li>Low code tools to enable automation, feedback, and asset management on Optimism.</li>
          <li>OP solutions for zero knowledge proofs and privacy preserving initiatives, on-chain reputation models.</li>
          <li>Tools for NFT creation, management, and marketplaces.</li>
          <li>Identity management, user analytics, and leaderboard template on OP.</li>
          <li>Web3 solutions for community, environment, and sustainability using a mix of IoT hardware, Optimism, and ecosystem tools.</li>
        </ul>

        <h1 className="containerH1">Optimism NFT marketplace and Scalability of Decentralized Public Goods Mobility Network:</h1>
        <p>
          Optimism NFT marketplace for drone and UAV spare parts and also for early-stage detection and prevention of incidents; NFC tags of UAVs for enabling sharing of government assets and service/repair of vital assets. Improving Data Transparency in Incident Management. We are also using Optimism to enable scaling of the decentralized public goods mobility network and effective management and communication setup for Drones utilized in Operations and Maintenance across multiple regions.        </p>
        <p>
          Optimism's license NFT registration module: Enable civic officials to register their drone driving licenses as well as their drone vehicle registration details in a decentralized manner. An individual can be identified by his/her SSN and a vehicle by Vehicle Registry Number both of which for now are integers between 0 and 65535 (16 bit integers). Every SSN or individual is associated with an address of an individual optimism account. We are also logging the identities of the driving license owners, their drone vehicle assets using exchange of unique identifiers powered by optimism.
        </p>
      </div>
     
      <div className="container textAlign">
        <h1 className="containerH1">Transport DAO : </h1>
        <div className="row">
          <div className=" col-md-12 col-lg-6">
            <img
              src="/images/Roadsafety.png"
              alt=""
              style={{ width: "100%" }}
            />
          </div>
          <div className=" col-md-12 col-lg-6">
            <p>
              Developer and optimism visualization tools for fleet and logistics
              organizations, connected vehicles for efficiency, safety and
              sustainability. Technical solution for citizens, fleet
              organizations and local governments to report and manage incidents
              using optimism, detect and prevent accidents on PC and Post PC
              devices. Monitoring tools on optimism for road incident management,
              reducing traffic congestion and enabling early detection of
              incidents. Benefits to optimism and the optimism eco-system: Developer and
              DAO tools on optimism for organization, tabulation, visualization of
              on-chain and off-chain data; Low code tools to enable automation,
              feedback and asset management; Developer tools for NFT creation,
              management and marketplaces,
            </p>
          </div>
        </div>
      </div>

      <br />
      <br />
      <div className="container">
        <div className="row">
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://github.com/aspiringsecurity/EthTransport#optimism-and-lit"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className=" image-button"
                src="images/Group 15.png"
                alt="github button"
                style={{ width: "100%" }}
              />
              Github Repository
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://www.youtube.com/watch?v=Jh_AFWc_kKI&ab_channel=AspiringDemos"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 10.jpg"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Website for civic bodies
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://sites.google.com/view/aspiringroadsafety/home"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 16 (1).png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Product Information, optimism Developer Tooling
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://youtu.be/BUiVvhuUdrE"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 17.png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Web Screencast
            </a>
          </div>
        </div>
      </div>

      <div className="container textAlign">
        <h1 className="containerH1">Contribution to Optimism Collective for OP RetroPGF3</h1>

        <ul>
          <li>
            <strong>User Information Site : </strong>
            <a
              href="https://sites.google.com/view/latcglobal/home"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>

          <li>
            <strong>Mobile screencast : </strong>
            <a
              href="https://drive.google.com/drive/u/4/folders/1wz2Fjpda3ZFFXd_cUnSw2dRvbw-vHtMm"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click Here
            </a>
          </li>
        </ul>
      </div>
      <div className="container textAlign">
        <h1 className="containerH1">
          {" "}
          Pharma Llama
        </h1>
        <div className="row">
          <div className=" col-md-12 col-lg-6">
            <img
              src="/images/Mask group.png"
              alt=""
              style={{ width: "100%" }}
            />
          </div>
          <div className=" col-md-12 col-lg-6">
            <p>
            Developer tools to manage and enable tracing, monitoring and recording of 
            medical public goods and pharma shipments across an entire supply chain 
            for efficiency and sustainability, reduce pharma fleet incidents 
            and benefit the entire medical eco-system. 
            
            Goal: Track, trace and record how pharma and public goods shipments travel across an entire supply chain using 
            Optimism blockchain, Optimism analytics tooling, Mode & Web3 ecosystem tools.

          Optimism Public Goods NFT storefront and marketplace for NFTs representing NFC tags of medical public goods 
          and pharma assets provided by government agencies (example GeM portal). This enables on-demand availability of 
          spare parts and prevents counterfeiting of expensive, repairable spare parts at functional locations. 
          Further, it enables optimal inventory management and allocation at all repair sites.
            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="container">
        <div className="row">
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://github.com/seetadev/PharmaLlama"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className=" image-button"
                src="images/Group 15.png"
                alt="github button"
                style={{ width: "100%" }}
              />
              Github Repository
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://ethglobal.com/showcase/pharma-llama-no518"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 10.jpg"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Project Page
            </a>
          </div>
          <div className=" col-md-3 col-lg-3">
            <a
              href="https://drive.google.com/drive/u/4/folders/1zparCtuoGOi-fb8LDxJ_-lmxiQvMNoB3"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 16 (1).png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Screencast: 
              <br />
              Demo Video for account abstraction, Mode Modules and OP Stack tooling 
            </a>
          </div>

          <div className=" col-md-3 col-lg-3">
            <a
              href=" https://www.youtube.com/watch?v=XOq55l0NIZI&t=1s"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/Group 17.png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Demo video 2
            </a>
          </div>
        </div>
      </div>
      <br />
      <div className="container textAlign">
        <strong>Collaboration with Base: Account Abstraction plugins using Base enables customization of verification logic via plugins with a rule/logic setting, tabulation, organization, visualization tool namely SocialCalc spreadsheet. This allows users to set up rules which their account has to abide by when executing transactions while being able to reconfigure them in the future. The process improves account security by restricting permissions certain keys have while remaining adaptable to the user's changing needs. Fleet role creation procedure; Fleet vehicles identification with NFC tags; Create credits of ratings earned via pollution checks, green fuel assets; Issue green credits for fleet vehicles via pollution checks by Transport department like Pollution check control; List green credits per fleet vehicle; Handle multiple vehicles.</strong>
      </div>

      <div className="container textAlign">
        <h1 className="containerH1">Project Links</h1>

        <ul>
          <li>
            <strong>Contribution to Optimism Collective for OP RetroPGF3: </strong>
            <a
              href="https://github.com/seetadev/PharmaLlama#optimism-public-goods"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>
        </ul>
      </div>
      
      <div className="container textAlign">
        <h1 className="containerH1">
          OP Kinematics 
        </h1>
        <div className="row">
          <div className=" col-md-12 col-lg-6">
            <img src="/images/opkin.png" alt="" style={{ width: "100%" }} />
          </div>
          <div className=" col-md-12 col-lg-6">
            <p>
            Developer tools to enable DeSci educators and Web3 game designers to create a kinematics playground and simulator to develop on-chain educational games using Optimism, Lattice's, MUD, 0xPARC, NFT.Storage and OSS Web3 tools.
            We wish to enable constructionist learning by empowering Web3 game developer community and DeSci educators to build educational games and teach concepts in Kinematics including  Newton Laws, acceleration due to gravity, circular motion, rotational motion and projectiles.
            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="container">
        <div className="row">
          <div className=" col-md-3 col-lg-6">
            <a
              href="https://github.com/aspiringsecurity/Web3KinematicsTools#optimism"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className=" image-button"
                src="images/githublong.png"
                alt="github button"
                style={{ width: "100%" }}
              />
              Github Repository
            </a>
          </div>
          <div className=" col-md-3 col-lg-6">
            <a
              href="https://drive.google.com/drive/u/2/folders/14I6_3TV_uRuZxnfMoKlkMCrgyDyBPCKa"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/alexander-shatov-niUkImZcSP8-unsplash 1.png"
                alt="youtube button"
                style={{ width: "100%" }}
              />
              Demo and Screenshots
            </a>
          </div>
        </div>
      </div>

      <div className="container textAlign">
        <h1 className="containerH1">Project Links</h1>

        <ul>
          <li>
            <strong>EthGlobal Project Page </strong>
            <a
              href="https://ethglobal.com/showcase/op-kinematics-ypsxy"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>
        </ul>
      </div>

      <div className="container textAlign">
        <h1 className="containerH1">
          Drones for Construction, Operations and Maintenance Activities
        </h1>
        <div className="row">
          <div className=" col-md-12 col-lg-6">
            <img src="/images/droneimg2.png" alt="" style={{ width: "100%" }} />
          </div>
          <div className=" col-md-12 col-lg-6">
            <p>
              Optimism NFT marketplace and Scalability of Decentralized Public Goods Mobility Network - Optimism NFT marketplace for drone and UAV spare parts and also for early-stage detection and prevention of incidents; NFC tags of UAVs for enabling sharing of government assets and service/repair of vital assets. Improving Data Transparency in Incident Management. We are also using Optimism to enable scaling of the decentralized public goods mobility network and effective management and communication setup for Drones utilized in Operations and Maintenance across multiple regions. Drones can be effectively utilized for building operations, inspection and maintenance and safer and more efficient surveys.

            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
      {/* <div className="container">
        <div className="row">
          <div className=" col-md-3 col-lg-6">
            <a
              href=" https://github.com/seetadev/EthOps"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className=" image-button"
                src="images/githublong.png"
                alt="github button"
                style={{ width: "100%" }}
              />
              Github Repository
            </a>
          </div>
          <div className=" col-md-3 col-lg-6">
            <a
              href=" https://github.com/seetadev/EthOps/tree/main/Module2/scaling-with-aurora "
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="image-button"
                src="images/githublong.png"
                alt="Github button"
                style={{ width: "100%" }}
              />
              Scaling with Aurora
            </a>
          </div>
        </div>
      </div> */}

      <div className="container textAlign">
        <h1 className="containerH1">Project Information</h1>

        <ul>
          <li>
            <strong>User Information Site : </strong>
            <a
              href="https://sites.google.com/view/dronesforrealestate/home "
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here
            </a>
          </li>
        </ul>
      </div>
      <br />
    </>
  );
}
